(function () {
  const bootstrapScript = document.currentScript;
  let runtimeRequested = false;

  function loadRuntime() {
    if (runtimeRequested || !bootstrapScript?.dataset.runtimeSrc) return;

    runtimeRequested = true;

    const script = document.createElement('script');
    script.src = bootstrapScript.dataset.runtimeSrc;
    script.dataset.integrationsSrc = bootstrapScript.dataset.integrationsSrc || '';
    script.dataset.chatarmin = bootstrapScript.dataset.chatarmin || 'false';
    script.dataset.reviewText = bootstrapScript.dataset.reviewText || '';
    script.dataset.singularReviewText = bootstrapScript.dataset.singularReviewText || '';
    script.async = true;
    document.head.appendChild(script);
  }

  document.addEventListener('visitorConsentCollected', () => {
    window.azConsentDecisionPending = true;
    loadRuntime();
  }, { once: true });

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadRuntime, { timeout: 1000 });
  } else {
    window.setTimeout(loadRuntime, 0);
  }
})();
